import { isPlanExists } from '@db/Plans/Check';
import { getCurrentUserId } from '@helpers/firebase/Auth';
import db, { parseFirestoreDoc } from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';
import { Like } from '@types';

export function parseLike(doc: db.DocumentSnapshot) {
  return parseFirestoreDoc<Like>(doc, 'userId');
}

export async function likePlan(planId: string) {
  const currentUserId = getCurrentUserId();
  const exists = await isPlanExists(planId);
  if (!exists) {
    throw Error('Cant like plan because it doesnt exist. planId=' + planId);
  }
  await db.setDoc(db.doc(firestore, 'plans', planId, 'likes', currentUserId), {
    createdAt: db.serverTimestamp(),
  });
}

export async function unlikePlan(planId: string) {
  const currentUserId = getCurrentUserId();
  await db.deleteDoc(db.doc(firestore, 'plans', planId, 'likes', currentUserId));
}

export async function userLikesPlan(userId: string, planId: string) {
  const docRef = await db.getDoc(db.doc(firestore, 'plans', planId, 'likes', userId));
  return docRef.exists();
}

export async function getPlanLikes(planId: string) {
  const querySnapshot = await db.getDocs(db.collection(firestore, 'plans', planId, 'likes'));
  return querySnapshot.docs.map((doc) => parseLike(doc));
}
